module.exports = __webpack_public_path__ + "img/IMG-20200723-WA0003.662ba9ca.jpg";